import "./login-confirmation.scss";
import { CdpaButtonComponent, CdpaButtonId } from "../../common/components/cdpaButton.component";
import { FormId } from "./common/formId";
import { attachValidationOnSubmitClick } from "./formHelpers/formHelpers";
export class LoginConfirmation {
    constructor() {
        const form = document.getElementById(FormId.LoginConfirmation);
        const submitButton = new CdpaButtonComponent(CdpaButtonId.LoginConfirmation);
        attachValidationOnSubmitClick(submitButton, form, []);
    }
}
